import { createContext, useContext, useMemo } from 'react';

import useAutoCallFeature from '@/app/mutations/Shared/useAutoCallFeature';

export interface Transcription {
  isTranscribing: boolean;
  start(): void;
  stop(): void;
}

export const TranscriptionContext = createContext<Transcription>(null!);

export function useTranscription() {
  return useContext(TranscriptionContext);
}

export function useAutoTranscription({ joined }: { joined: boolean }, isEnabled: boolean) {
  const transcription = useTranscription();
  const feature = useMemo(() => ({
    isActive: transcription.isTranscribing,
    start: transcription.start,
    stop: transcription.stop,
  }), [transcription.isTranscribing, transcription.start, transcription.stop]);
  useAutoCallFeature({ joined, isEnabled }, feature);
}
